export default __webpack_public_path__ + "static/media/granville08.b0af6476.jpg";